<h5 class="mb-4">Contract Hours p/w</h5>

@if (contractHours().length > 0) {
  <app-sortable-table [headers]="headers" class="table-striped">
    @for (hours of contractHours(); track hours) {
      <tr>
        <td>{{ hours.hours }}</td>
        <td>{{ hours.startDate | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</td>
      </tr>
    }
  </app-sortable-table>
}